import { FC, ReactNode, useCallback, useState } from 'react';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Box, FormControlLabel, Modal, Switch, Typography } from '@mui/material';
import { useAppDispatch } from '~/redux';
import { closeModalById } from '~/redux/slices/modalSlice';
import { ModalHeader } from '.';
import { modalActionBlockStyles, modalSmallContainerStyle } from './styles';

export interface ConfirmModalProps {
  payload: {
    id: string;
    onSubmit: () => void;
    title: string | ReactNode;
    description?: string;
    confirmButtonLabel?: string;
    confirmationLabel?: string;
    showConfirmationControl?: boolean;
    showActionControl?: boolean;
  };
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  payload: {
    id,
    onSubmit,
    title,
    description,
    confirmButtonLabel = 'Submit',
    confirmationLabel,
    showConfirmationControl = false,
    showActionControl = true,
  },
}) => {
  const dispatch = useAppDispatch();
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    setConfirmed(false);
    dispatch(closeModalById(id));
  }, [dispatch, id]);

  return (
    <Modal open onClose={handleClose}>
      <Box tabIndex={-1} sx={modalSmallContainerStyle}>
        <ModalHeader onClose={handleClose} title={[title]} />
        <Typography variant="body1" p="12px 16px">
          {description}
        </Typography>
        {showConfirmationControl && (
          <Box p="12px 16px">
            <Typography variant="bodyLarge" component="div" mb="16px">
              {confirmationLabel}
            </Typography>
            <FormControlLabel
              sx={{ ml: 0 }}
              labelPlacement="end"
              label="I understand and wish to proceed with this action."
              control={<Switch onChange={() => setConfirmed(!confirmed)} sx={{ mr: '1rem' }} />}
            />
          </Box>
        )}
        {showActionControl && (
          <Box sx={modalActionBlockStyles}>
            <CustomButton buttonType="borderless" label="Cancel" onClick={handleClose} />
            <CustomButton
              label={confirmButtonLabel}
              disabled={!confirmed && showConfirmationControl}
              type="submit"
              onClick={() => {
                onSubmit();
                handleClose();
              }}
            />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
